
  import Vue from 'vue'
  import pageMixin from "@/mixins/page";
  import {BreadcrumbItems, BreadcrumbItemType} from "@/utils/breadcrumb";
  import {getBrandFolderName} from "@/utils/common";

  const brandFolderName = getBrandFolderName();

  export default Vue.extend({
    name: "Privacy",
    mixins: [pageMixin],
    components: {
      PwaPrivacy: () => import(`@/components/privacy/${brandFolderName}/PwaPrivacy.vue`),
    },
    data() {
      return {
        breadcrumb: [{labelId: BreadcrumbItems.privacy.labelId}] as BreadcrumbItemType[],
      };
    },
  });
